import { useMemo } from 'react';
import {
  compareApplicationTypes,
  getApplicationTypeDetailLabel,
  IEvent,
} from 'types';

function useParticipantCount(event?: IEvent) {
  return useMemo(() => {
    if (!event) return '';
    if (event.applicationTypeQuota) {
      // '일반(혼자)(10)' 처럼 괄호가 겹치지 않게 정원은 괄호 대신 'N명' 으로 붙인다.
      return Object.entries(event.applicationTypeQuota)
        .sort(([a], [b]) => compareApplicationTypes(a, b))
        .map(
          ([key, value]) =>
            `${getApplicationTypeDetailLabel(key, event.applicationTypeQuotaTitle)} ${value}명`,
        )
        .join(', ');
    }

    return `${event.participantCount}명`;
  }, [event]);
}

export default useParticipantCount;
